import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';

import { Card } from 'material-ui/Card';
import CategoryCard from './CategoryCard';
import CourseCard from '../Course/CourseCard';
import DetailView from '../Common/DetailView';
import ModuleListItem from '../Module/ModuleListItem.react';
import ResourceCard from '../Module/ResourceCard';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import ListIcon from 'material-ui/svg-icons/action/list';
import ModuleIcon from 'material-ui/svg-icons/social/school';
import SearchIcon from 'material-ui/svg-icons/action/search';

import CategoryActions from '../../actions/CategoryActionCreator';
import CourseActions from '../../actions/CourseActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';
import CategoryStore from '../../stores/CategoryStore';
import CourseStore from '../../stores/CourseStore';
import ModuleStore from '../../stores/ModuleStore';
import StatStore from '../../stores/StatStore';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';

const validTypes = new Set(['courses', 'modules', 'resources']);
let types = new Set();

const getActions = (id, onDelete = null, canEdit = false, canAddContent = false) => [
    {
        link: `/dashboard/library/list`,
        icon: <ListIcon />,
        label: 'Categories',

    },
    {
        link: `/dashboard/category/${id}/media/search`,
        icon: <SearchIcon />,
        label: 'Search',
        condition: {
            show: !!id
        }
    },
    { type: 'divider' },
    {
        link: `/dashboard/module/new?category=${id}`,
        icon: <ModuleIcon />,
        label: 'Add Module',
        condition: {
            roles: [ROLES.ADMIN],
            show: canAddContent && !!id
        }
    },
    { type: 'divider' },
    {
        link: `/dashboard/category/${id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            roles: [ROLES.ADMIN],
            show: canEdit && !!id
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: id,
        title: 'Delete ',
        deleteAction: onDelete,
        message: (<span>Are you sure you want to delete this category?</span>),
        condition: {
            roles: [ROLES.ADMIN],
            show: canEdit && !!id && !!onDelete
        }
    },
    { type: 'divider' },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

class Library extends Component {

    buildTypes() {
        if (validTypes.has(this.props.routeParams.type)) {
            types.add(this.props.routeParams.type)
        } else {
            types = validTypes;
        }
    }

    componentDidMount() {
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onCourseChange = this.onCourseChange.bind(this);
        this.onModuleChange = this.onModuleChange.bind(this);
        this.onDelete = this.onDelete.bind(this);

        this.buildTypes();

        this.listeners = [
            CategoryStore.addListener(this.onCategoryChange),
            CourseStore.addListener(this.onCourseChange),
            ModuleStore.addListener(this.onModuleChange),
        ];

        CategoryActions.getAllWithCount();
        if (!!this.props.id) {
            CourseActions.getByCategory(this.props.id);
            ModuleActions.getByCategory(this.props.id);
        }

        this.setState({actions: buildContextMenu(getActions(this.props.id), this.context.auth)});
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== this.props.id) {
            let title, description, subcategories, ancestors, colour, image, actions;
            this.setState({
                courses: [],
                modules: [],
                resources: [],
                actions: buildContextMenu(getActions(nextProps.id), this.context.auth)
            });

            if (!!nextProps.id) {
                CourseActions.getByCategory(nextProps.id);
                ModuleActions.getByCategory(nextProps.id);
                subcategories = CategoryStore.getByParent(nextProps.id);
                ancestors = CategoryStore.getAncestors(nextProps.id);
                const category = CategoryStore.getById(nextProps.id);
                title = category.name;
                description = category.description;
                if (!!category.colour) {
                    colour = category.colour;
                }
                if (!!category.image) {
                    image = category.image;
                }
                actions = buildContextMenu(getActions(nextProps.id, !category.isDefault && this.onDelete, category.canEdit, category.canAddContent), this.context.auth);
            } else {
                subcategories = CategoryStore.getRoots();
                ancestors = [];
                title = 'Library';
                description = '';
            }
            this.setState({
                title,
                description,
                colour,
                image,
                subcategories,
                ancestors,
                actions: actions || this.state.actions
            });
        }
    }

    render() {

        let heroContent;
        if (this.props.id) {

            const css = (!!this.state.colour ?  { backgroundColor: this.state.colour } : {});

            let breadcrumbs = [<li key="root"><Link to="/dashboard/library">Library</Link></li>];
            if (this.state.ancestors.length) {
                this.state.ancestors.forEach(({id, name}, index) => {
                    if (index !== (this.state.ancestors.length - 1)) {
                        breadcrumbs.push(<li key={`sep${index}`}> &gt; </li>);
                        breadcrumbs.push(<li key={`li${index}`}><Link to={`/dashboard/library/${id}`} key={id}>{name}</Link></li>);
                    }
                });
            }

            heroContent = (
                <div className="cent-hero-space" style={css} key="description" >
                    <div className='cent-container'>
                        <div className="cent-hero"  >
                        </div>
                        <div className="cent-hero-content" >
                            <ol className="cent-breadcrumbs">
                                {breadcrumbs}
                            </ol>
                            <h2>{this.state.title}</h2>
                            <p>{this.state.description}</p>
                        </div>
                    </div>
                </div>
            );
        }


        const isAdmin = this.context.auth.isAdmin();
        let subCategoriesList = this.state.subcategories
            .filter(({totalCourses = 0, totalModules = 0}) => isAdmin || (totalModules + totalCourses > 0))
            .map((cat) => (
                <CategoryCard
                    key={cat.id}
                    category={cat}
                    courseCount={Number(cat.totalCourses) || 0}
                    resourceCount={Number(cat.totalResources) || 0}
                    colour={this.state.colour}
                />
            ));

        const subCategories = (subCategoriesList.length > 0) && (
            <div className="cent-cards">
                {subCategoriesList}
            </div>
        );

        let courses;
        if (this.state.courses.length && types.has('courses')) {
            courses = (
                <div className="cent-cards">
                    {this.state.courses.map( (course) => (<CourseCard key={course.id} {...course} /> ))}
                </div>
            );
        }

        let modules;
        if (this.state.modules.length && types.has('modules')) {
            let moduleList = this.state.modules.map( (module, i) => (
                <Card className="cent-card cent-card-list-item" key={i}>
                    <ModuleListItem
                        key={module.id}
                        data={module}
                        link={`/dashboard/category/${this.props.id}/module/${module.id}`}
                    />
                </Card>
            ));
            modules = (
                <div className="cent-cards">
                    <div className="cent-cards-header">
                        <h3>Modules</h3>
                    </div>
                        {moduleList}
                </div>
            );
        }

        let resources;
        if (this.state.resources.length && types.has('resources')) {
            resources = (
                <div className="cent-cards">
                    <div className="cent-cards-header">
                        <h3>Resources</h3>
                    </div>
                    {this.state.resources.map( (resource) => (<ResourceCard key={resource.id} {...resource}/>))}
                </div>
            );
        }

        return (
            <DetailView
                title="Library"
                actions={this.state.actions}
                searchAction={CategoryStore.search}
            >
                {heroContent}
                {courses}
                {modules}
                {resources}
                {subCategories}
            </DetailView>
        );
    }

    onCategoryChange() {
        const subcategories = !this.props.id ? CategoryStore.getRoots() : CategoryStore.getByParent(this.props.id);
        if (!!subcategories) {
            this.setState({subcategories});
        }
        if (!!this.props.id) {
            const { name, description, colour, image, canEdit, canAddContent, isDefault } = CategoryStore.getById(this.props.id);
            if (!!name) {
                this.setState({
                    title: name,
                    description,
                    colour,
                    image,
                    actions: buildContextMenu(getActions(this.props.id, !isDefault && this.onDelete, canEdit, canAddContent), this.context.auth)
                });
            }
            const ancestors = CategoryStore.getAncestors(this.props.id);
            if (!!ancestors) {
                this.setState({ancestors});
            }
        }
    }

    onCourseChange() {
        if (!!this.props.id) {
            const courses = CourseStore.getByCategory(this.props.id);
            if (!!courses) {
                this.setState({courses});
            }
        }
    }

    onModuleChange() {
        if (!!this.props.id) {
            const allModules = ModuleStore.getByCategory(this.props.id);
            if (!!allModules) {
                let modules = [], resources = [];
                allModules.forEach((m) => {
                    if (m.type === 'resource') {
                        resources.push(m);
                    } else {
                        modules.push(m);
                    }
                });
                this.setState({modules, resources});
            }
        }
    }

    onDelete(entityId) {
        if (Number(entityId) === Number(this.props.id)) {
            CategoryActions.delete(entityId);
            browserHistory.goBack();
        }
    }

}

Library.getStores = () => ([StatStore]);
Library.calculateState = (prevState) => (prevState || {
    title: 'Library',
    description: '',
    colour: 'rgb(31, 115, 146)',
    image: '',
    subcategories: [],
    courses: [],
    modules: [],
    resources: [],
    ancestors: [],
    actions: null,
});

Library.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default withId(Container.create(Library), ({routeParams}) => ({id: Number(routeParams.id)}));
